module.exports = __webpack_public_path__ + "img/25.b021ea64.jpg";